import React, { useState } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import axios from "axios";
import privileges from "./privileges";

const InitializeToken = (props) => {

  const initialState = axios.defaults.headers && axios.defaults.headers.Authorization ? "Done" : "Loading";
  const [tokenLoaded, setTokenLoaded] = useState(initialState);
  const [privilegeList, setPrivilegeList] = useState(null);

  const { getAccessTokenWithPopup, getAccessTokenSilently } = useAuth0();

  if (initialState !== "Done") {
    if (!privilegeList){
      privileges({callback: (privilegeList)=> {
        setPrivilegeList(privilegeList);
        // setTokenLoaded("Checking");      
      }});
    } else {
      try {      
        getAccessTokenSilently({
          audience: `${process.env.REACT_APP_AUTH0_AUDIENCE}`,
          scope: privilegeList,
        }).then((token) => {
          axios.defaults.headers = { Authorization: `Bearer ${token}` };
          setTokenLoaded("Done");      
        }).catch((err) => {
          if (err.error === "login_required") {
            setTokenLoaded("Done");
          } else {
            console.log("Failed to retrieve token, will try with popup", err);
            getAccessTokenWithPopup({
              scope: privilegeList,
              audience: `${process.env.REACT_APP_AUTH0_AUDIENCE}`,
            }).then((token) => {
              axios.defaults.headers = { Authorization: `Bearer ${token}` };
              setTokenLoaded("Done");
            }).catch((err) => {
              console.log("Failed to retrieve token", err);
              setTokenLoaded("Failed");
            });
          }
        });
      } catch (err) {
        setTokenLoaded("Failed");      
      }
    }
  }

  return (
    <div>
      {tokenLoaded === "Done"
        ? props.children
        :
        <div>
          <img src={process.env.REACT_APP_COMPANY_LOGO ? process.env.REACT_APP_COMPANY_LOGO : "images/logo.png"} alt="logo" />
          <div style={{marginTop:80, width: "100%", textAlign: "center"}}>
            <h2>{tokenLoaded} Authorization</h2>
          </div>
        </div>}
    </div>
  )
}

export default InitializeToken;